<div class="p-3">
  <h5 class="text-danger mb-3">Détails de l'échec</h5>

  <div class="row mb-2" *ngIf="errorRecord.source">
    <span class="col-sm-3 fw-bold">Source :</span>
    <span class="col-sm-9">{{ errorRecord.source }}</span>
  </div>

  <div class="row mb-2" *ngIf="errorRecord.reason">
    <span class="col-sm-3 fw-bold">Raison :</span>
    <span class="col-sm-9">{{ errorRecord.reason }}</span>
  </div>

  <div class="row mb-2" *ngIf="errorRecord.occurredAt">
    <span class="col-sm-3 fw-bold">Date de l'erreur :</span>
    <span class="col-sm-9">{{ errorRecord.occurredAt | date:'dd/MM/yyyy HH:mm:ss' }}</span>
  </div>

  <div class="row mb-2" *ngIf="errorRecord.savReference">
    <span class="col-sm-3 fw-bold">Référence SAV :</span>
    <span class="col-sm-9">{{ errorRecord.savReference }}</span>
  </div>

  <hr *ngIf="errorRecord.analysisDate || errorRecord.analysisConclusion" />

  <div class="row mb-2" *ngIf="errorRecord.analysisDate">
    <span class="col-sm-3 fw-bold">Date d'analyse :</span>
    <span class="col-sm-9">{{ errorRecord.analysisDate | date:'dd/MM/yyyy' }}</span>
  </div>

  <div class="row mb-2" *ngIf="errorRecord.analysisConclusion">
    <span class="col-sm-3 fw-bold">Conclusion :</span>
    <span class="col-sm-9">{{ errorRecord.analysisConclusion }}</span>
  </div>
</div>
